export const skipFalsy = <T>(
  ...value: (T | false | '' | null | undefined | 0)[]
): T[] => value.filter(Boolean) as T[]

export const names = (
  ...classNames: (string | false | '' | null | undefined | number | 0)[]
): string => skipFalsy(...classNames).join(' ')
